import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=540a9332&scoped=true&"
import script from "./TopBar.vue?vue&type=script&lang=ts&"
export * from "./TopBar.vue?vue&type=script&lang=ts&"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=540a9332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540a9332",
  null
  
)

export default component.exports